import React, { type ComponentProps } from 'react'

import { type Citation } from '../../../../../views/AIAgent/AIAgentResultCitations/AIAgentResultCitations'
import { type AIAgentResultState, EditableAIAgentResult } from '../../../../../views/AIAgent/EditableAIAgentResult/EditableAIAgentResult'
import { CitationNodeContext } from '../../MeetingSummary/MeetingResults/Lexical/Nodes/CitationNode/CitationNodeContext'
import { ReadOnlyLexicalEditor } from '../../MeetingSummary/MeetingResults/Lexical/ReadOnlyLexicalEditor/ReadOnlyLexicalEditor'
import { CITATION_LEXICAL_NODES } from '../../MeetingSummary/MeetingResults/Lexical/nodes'

type MeetingPrepSummaryEditableProps = Pick<
  ComponentProps<typeof EditableAIAgentResult>,
  'handleInteraction' | 'isLoading' | 'interactionIsLoading' | 'ActionButtonsComponent' | 'EditButtonComponent'
>

interface MeetingPrepSummaryProps {
  documentState: AIAgentResultState
  citations: Citation[]
  readOnly?: boolean
  editableProps?: MeetingPrepSummaryEditableProps
}

export const MeetingPrepSummary: React.FC<MeetingPrepSummaryProps> = ({ documentState, citations, readOnly = false, editableProps }) => (
  <CitationNodeContext.Provider value={{ citations }}>
    {readOnly || !editableProps ? (
      <ReadOnlyLexicalEditor key={documentState.displayId} initialEditorState={documentState.editorState} lexicalNodes={CITATION_LEXICAL_NODES} />
    ) : (
      <EditableAIAgentResult label='Summary' aiAgentResultState={documentState} collapsible={true} {...editableProps} />
    )}
  </CitationNodeContext.Provider>
)
